import { DataDate } from "../model/data_date";
import { Series } from "../model/series";
import { tablemill } from "../tablemill_metal";
import { EasyResearchesForm } from "../view/easy_researches_form";
import $ from "jquery";

class EasyResearchesController {
  private form!: JQuery<HTMLFormElement>;
  private selectedResearchTypeInput!: JQuery<HTMLInputElement>;
  private selectedItemAspectNamesInput!: JQuery<HTMLInputElement>;
  private selectedItemAspectNames: string[] = [];
  private view: EasyResearchesForm;
  private formModel: EasyResearchesControllerForm;
  private currentSelectedItemId: number | null = null;

  constructor() {
    this.formModel = new EasyResearchesControllerForm();
    this.view = new EasyResearchesForm();
  }

  onLoad(): void {
    this.initialize();
    this.bindEvents();
    this.renderGraph();

    // 初期表示時にtrend_calculation_descriptionをレンダリング
    this.renderInitialTrendCalculation();

    // 初期表示時にtrend_graph_descriptionをレンダリング
    this.renderInitialTrendGraphDescription();

    // 初期表示時にcombination_keyword_headerを更新
    this.updateCombinationKeywordHeader();
  }

  private initialize(): void {
    this.form = $("#easy_research_form") as JQuery<HTMLFormElement>;
    this.selectedResearchTypeInput = $("#selected_research_type") as JQuery<HTMLInputElement>;
    this.selectedItemAspectNamesInput = $("#selected_item_aspect_names") as JQuery<HTMLInputElement>;

    // 現在の値を取得して選択状態を反映
    const currentResearchType = (this.selectedResearchTypeInput.val() as string) || "trend";
    const currentItemAspectName = (this.selectedItemAspectNamesInput.val() as string) || "cooking_method";

    this.updateResearchTypeSelection(currentResearchType);
    this.updateItemAspectSelection(currentItemAspectName);
  }

  private updateResearchTypeSelection(researchType: string): void {
    // ラジオボタンの選択状態を更新
    const $radioButtons = $("#type_radio_group input[type='radio']");
    $radioButtons.prop("checked", false);
    const $selectedRadio = $(`#type_radio_group input[type='radio'][data-type="${researchType}"]`);
    $selectedRadio.prop("checked", true);

    this.selectedResearchTypeInput.val(researchType);
  }

  private updateItemAspectSelection(itemAspectName: string): void {
    // 選択された名前を取得（最初の1つだけ、単一選択）
    const name = itemAspectName ? itemAspectName.split(",")[0].trim() : "cooking_method";
    this.selectedItemAspectNames = [name];

    // ラジオボタンの選択状態を更新
    const $radioButtons = $("#item_aspect_radio_group input[type='radio']");
    $radioButtons.prop("checked", false);
    const $selectedRadio = $(`#item_aspect_radio_group input[type='radio'][data-item-aspect-name="${name}"]`);
    $selectedRadio.prop("checked", true);

    this.selectedItemAspectNamesInput.val(name);
  }

  private bindEvents(): void {
    // Research type radio button selection (single selection)
    $(document).on("change", "#type_radio_group input[type='radio'].type_radio", (e: JQuery.ChangeEvent) => {
      const $radio = $(e.currentTarget);
      const researchType = $radio.data("type") as string;

      // 選択状態を更新
      this.updateResearchTypeSelection(researchType);

      // パラメーターを更新してフォームを送信
      this.updateAndSubmit();
      return false;
    });

    // Item aspect radio button selection (single selection)
    $(document).on("change", "#item_aspect_radio_group input[type='radio'].item_aspect_radio", (e: JQuery.ChangeEvent) => {
      const $radio = $(e.currentTarget);
      const itemAspectName = $radio.data("item-aspect-name") as string;

      // 選択状態を更新（単一選択）
      this.updateItemAspectSelection(itemAspectName);

      // パラメーターを更新してフォームを送信
      this.updateAndSubmit();
      return false;
    });

    // Form submission
    this.form.on("submit", (e) => {
      if (this.selectedItemAspectNames.length === 0 || !this.selectedItemAspectNames[0]) {
        e.preventDefault();
        alert("大分類を選択してください。");
        return false;
      }

      // Form will submit normally (GET request)
      return true;
    });

    // 検索ボックスでEnterキーを押したときにフォームを送信
    $("#keyword").on("keypress", (e: JQuery.KeyPressEvent) => {
      if (e.which === 13) { // Enter key
        e.preventDefault();
        this.updateAndSubmit();
        return false;
      }
    });

    // タグのクリックイベントを登録
    $(document).on("click", ".combination_keywords .partition_button", (e: JQuery.ClickEvent) => {
      const $tag = $(e.currentTarget);
      const itemId = parseInt($tag.data("itemId") as string, 10);
      const itemName = $tag.data("itemName") as string;

      if (itemId && itemName) {
        this.selectKeywordTag(itemId, itemName);
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }

  private selectKeywordTag(itemId: number, itemName: string): void {
    // 選択されたitem_idをメモリに保存
    this.currentSelectedItemId = itemId;

    // すべてのタグからselectedクラスを削除
    $(".combination_keywords .partition_button").removeClass("selected");

    // クリックされたタグにselectedクラスを追加
    const $clickedTag = $(`.combination_keywords .partition_button[data-item-id="${itemId}"]`);
    $clickedTag.addClass("selected");

    // selectionをクリアして、選択されたitem_idを1つだけ追加
    this.formModel.selection.clear();
    this.formModel.selection.add(itemId);

    const increaseRate = parseFloat($clickedTag.data("increaseRate") as string) || 0.0;
    const matchRate = parseFloat($clickedTag.data("matchRate") as string) || 0.0;
    const endDate = new Date();
    const currentYear = endDate.getFullYear();
    const lastYear = currentYear - 1;
    const keyword = this.formModel.keyword();
    const researchType = ($("input[name='research_type']:checked").val() as string)
      || this.selectedResearchTypeInput.val() as string
      || "trend";
    const trendCalculations = [{
      keyword_name: itemName,
      increase_rate: increaseRate,
      match_rate: matchRate
    }];
    this.renderTrendCalculation(keyword, trendCalculations, lastYear, currentYear, researchType);

    // 組み合わせキーワードヘッダーを更新
    this.updateCombinationKeywordHeader(itemName);

    // グラフを再描画
    this.updateGraphForSelection();
  }

  private updateGraphForSelection(): void {
    // 既存のシリーズをすべて削除
    const seriesCount = this.view.graph.seriesCount();
    for (let i = seriesCount - 1; i >= 0; i--) {
      const series = this.view.graph.getSeries(i);
      this.view.graph.removeSeries(series);
    }

    // グラフをクリア
    this.view.graph.clear();

    // 新しいグラフを描画
    this.renderGraph();
  }

  private renderGraph(): void {
    // 最初のキーワードを自動的に選択（4つのキーワードのうち最初の1つ）
    const selectionItems = this.currentSelectedItemId !== null
      ? [this.currentSelectedItemId]
      : this.formModel.selection.items();

    // 選択されたキーワードがない場合は、最初のキーワードを取得
    if (selectionItems.length === 0) {
      const $firstTag = $(".combination_keywords .partition_button").first();
      if ($firstTag.length > 0) {
        const firstItemId = parseInt($firstTag.data("itemId") as string, 10);
        if (firstItemId) {
          selectionItems.push(firstItemId);
          this.currentSelectedItemId = firstItemId;
          this.formModel.selection.clear();
          this.formModel.selection.add(firstItemId);
        }
      }
    }

    if (selectionItems.length === 0) {
      return;
    }

    // グラフを描画
    const graphPromises = selectionItems.map((pairingItemId: number) => this.renderEachGraph(pairingItemId));

    if (graphPromises.length === 0) {
      return;
    }

    $.when(...graphPromises).done((...results: any[]) => {
      results.forEach((series: any) => {
        this.view.graph.addSeries(series);
      });
      if (this.view.graph.hasNoData()) {
        this.view.showNoDataMessage();
      } else {
        this.view.render();
      }
      this.view.enablePngDownload();
      this.view.updateCsvUrl(
        this.formModel
          .newCombinationDataSeriesQuery(null, this.formModel.selection.items())
          .csvUrl(),
      );
      this.updateCombinationKeywordHeader();
    }).fail((error: any) => {
      this.view.showHttpErrorMessage(error);
    });
  }

  private renderEachGraph(pairingItemId: number): JQuery.Promise<any> {
    const dfd = $.Deferred<any>();
    const query = this.formModel.newCombinationDataSeriesQuery(pairingItemId);

    query.execute().then(
      (series: any) => {
        series.itemId = pairingItemId;
        dfd.resolve(series);
      },
      (error: any) => {
        dfd.reject(error);
      },
    );
    return dfd.promise();
  }

  private updateAndSubmit(): void {
    // パラメーターを更新
    const researchTypeValue = this.selectedResearchTypeInput.val() as string;
    const itemAspectNameValue = this.selectedItemAspectNames[0] || "cooking_method";

    this.selectedResearchTypeInput.val(researchTypeValue || "trend");
    this.selectedItemAspectNamesInput.val(itemAspectNameValue);

    // フォームを送信
    this.form.submit();
  }

  private renderInitialTrendCalculation(): void {
    const $container = $("#trend_calculation_description");
    if ($container.length === 0) {
      return;
    }

    const keyword = $container.data("keyword") as string;
    const trendCalculationsData = $container.data("trendCalculations");
    const researchType = (this.selectedResearchTypeInput.val() as string) || ($container.data("researchType") as string) || "trend";

    if (researchType === "regular") {
      const $selectedTag = $(".combination_keywords .partition_button.selected");
      if ($selectedTag.length > 0 && keyword) {
        const itemName = $selectedTag.data("itemName") as string;
        const matchRate = parseFloat($selectedTag.data("matchRate") as string) || 0.0;
        const trendCalculations = [{ keyword_name: itemName, increase_rate: 0, match_rate: matchRate }];
        this.renderTrendCalculation(keyword, trendCalculations, 0, 0, researchType);
      }
      return;
    }

    if (!keyword || !trendCalculationsData) {
      return;
    }

    // jQueryのdata()メソッドはJSON文字列を自動的にパースする場合があるため、
    // 文字列の場合はパースし、既にオブジェクトの場合はそのまま使用
    let trendCalculations: Array<{ keyword_name: string; increase_rate: number }> = [];
    if (typeof trendCalculationsData === "string") {
      try {
        trendCalculations = JSON.parse(trendCalculationsData);
      } catch (e) {
        console.error("Failed to parse trend_calculations:", e);
        return;
      }
    } else if (Array.isArray(trendCalculationsData)) {
      trendCalculations = trendCalculationsData;
    } else {
      console.error("Invalid trend_calculations data type");
      return;
    }

    const endDate = new Date();
    const currentYear = endDate.getFullYear();
    const lastYear = currentYear - 1;

    this.renderTrendCalculation(keyword, trendCalculations, lastYear, currentYear, researchType);
  }

  private renderInitialTrendGraphDescription(): void {
    const $selectedTag = $(".combination_keywords .partition_button.selected");
    if ($selectedTag.length === 0) {
      return;
    }

    const researchType = ($("input[name='research_type']:checked").val() as string)
      || this.selectedResearchTypeInput.val() as string
      || "trend";
    if (researchType === "regular") {
      return;
    }

    const itemName = $selectedTag.data("itemName") as string;
    const increaseRate = parseFloat($selectedTag.data("increaseRate") as string) || 0.0;

    if (itemName) {
      this.updateTrendGraphDescription(itemName, increaseRate);
    }
  }

  private renderTrendCalculation(
    keyword: string,
    trendCalculations: Array<{ keyword_name: string; increase_rate: number; match_rate?: number }>,
    lastYear: number,
    currentYear: number,
    researchType: string = "trend"
  ): void {
    const $container = $("#trend_calculation_description");
    let html = "";

    if (researchType === "regular") {
      if (trendCalculations && trendCalculations.length > 0) {
        const escapedKeyword = this.escapeHtml(keyword);
        trendCalculations.forEach((calc) => {
          const escapedKeywordName = this.escapeHtml(calc.keyword_name);
          const matchRatePercent = (calc.match_rate || 0).toFixed(1);
          html += `<p class="description">
            昨年の<b>「${escapedKeyword}×〇〇」</b>の検索のうち<b>「${escapedKeyword}×${escapedKeywordName}」</b>の検索は、約<b>${matchRatePercent}%</b>です。
          </p>`;
        });
      }
      $container.html(html);
      return;
    }

    if (trendCalculations && trendCalculations.length > 0) {
      const escapedKeyword = this.escapeHtml(keyword);

      trendCalculations.forEach((calc, index) => {
        const escapedKeywordName = this.escapeHtml(calc.keyword_name);
        const formattedIncreaseRate = calc.increase_rate >= 0
          ? `+${calc.increase_rate.toFixed(1)}%`
          : `${calc.increase_rate.toFixed(1)}%`;

        if (calc.increase_rate > 0) {
          html += `<p class="description">
            <b>「${escapedKeyword}」</b>
            ×
            <b>「${escapedKeywordName}」</b>
            の組み合わせは、前年比で
            <b>${formattedIncreaseRate}</b>
            の上昇を示しています(赤丸箇所)。
          </p>`;
        } else {
          html += `<p class="description">
            <b>「${escapedKeyword}」</b>
            ×
            <b>「${escapedKeywordName}」</b>
            の組み合わせは、前年比で
            <b>${formattedIncreaseRate}</b>
            の減少を示しています(赤丸箇所)。
          </p>`;
        }

        if (index < trendCalculations.length - 1) {
          html += "<br>";
        }
      });
    }
    else {
      html = `<span></span>`;
    }

    $container.html(html);
  }

  private updateTrendGraphDescription(_itemName: string, _increaseRate: number): void {
    const $container = $("#trend_graph_description");
    if ($container.length === 0) {
      return;
    }

    const researchType = ($("input[name='research_type']:checked").val() as string)
      || this.selectedResearchTypeInput.val() as string
      || "trend";
    if (researchType === "regular") {
      $container.html("");
      return;
    }

    $container.html(`
      <p class="annotation">
      破線部分は今月以降のSI値の着地見通しを示しております。昨年同月のSI値に、直近24ヶ月間のSI値の変化傾向を反映した係数を乗じています。
      </p>
    `);
  }

  private updateCombinationKeywordHeader(itemName?: string): void {
    const $header = $(".combination_keyword_header");
    if ($header.length === 0) {
      return;
    }

    const keyword = this.formModel.keyword();
    const escapedKeyword = this.escapeHtml(keyword);
    const displayItemName = itemName || $(".combination_keywords .partition_button.selected").data("itemName") as string || "";
    const escapedItemName = this.escapeHtml(displayItemName);

    if (displayItemName) {
      $header.html(`
        <b>「${escapedKeyword}」</b>
        ×
        <b>「${escapedItemName}」</b>
      `);
    }
  }

  private escapeHtml(text: string): string {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}

class EasyResearchesControllerForm {
  selection: ItemSelection;

  constructor() {
    this.selection = new ItemSelection();
  }

  formElement(): JQuery<HTMLElement> {
    return $("#easy_research_form");
  }

  combinationDataSeriesUrl(): string {
    // 「定番」の場合はcombination_stats_pathエンドポイントを使用
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      const itemId = this.itemId();
      return `/combinations/${itemId}/stats.json`;
    }
    return $("#ksi_graph").data("ajaxUrl");
  }

  type(): string {
    // 「定番」の場合はkmr、それ以外はksiを使用
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      return $("#type").val() as string || "kmr";
    }
    // CombinationDataSeriesQueryはksi, ksv, kmrなどのタイプを期待する
    // easy_researchesでは常にksiを使用
    return $("#type").val() as string || "ksi";
  }

  partition(): string {
    // 「定番」の場合はyearly、それ以外はmonthlyを使用
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      return "yearly";
    }
    return $("#partition").val() as string || "monthly";
  }

  targetDataDate(): any {
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      // 「定番」の場合はendパラメーターから取得（yearly partition用）
      const endDate = $("#end").val() as string;
      if (endDate) {
        return DataDate.parseYMD(endDate, "yearly");
      }
      // フォールバック: 現在年の開始日（1月1日）をYYYY-MM-DD形式で取得
      const today = new Date();
      const year = today.getFullYear();
      const yearStartStr = `${year}-01-01`;
      return DataDate.parseYMD(yearStartStr, "yearly");
    }
    return DataDate.parseYMD($("#target").val() as string, this.partition());
  }

  startDate(): string {
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      // 「定番」の場合はstartパラメーターから取得
      const startDate = $("#start").val() as string;
      if (startDate) {
        return startDate;
      }
      // フォールバック: 2009-01-01
      return "2009-01-01";
    }
    return "";
  }

  dimension(): string {
    return $("#dimension").val() as string || "area";
  }

  area(): string {
    return $("#area").val() as string || "";
  }

  category(): string {
    return $("#category").val() as string || "";
  }

  keyword(): string {
    return $("#keyword").val() as string;
  }

  itemId(): string {
    return $("#item_id").val() as string;
  }

  newCombinationDataSeriesQuery(
    pairingItemId?: number | null,
    selection?: number[],
  ): CombinationDataSeriesQuery {
    return new CombinationDataSeriesQuery(this, pairingItemId, selection);
  }
}

class ItemSelection {
  private static readonly ITEM_CLASS = "selectingItemId";

  private containerElement(): JQuery<HTMLElement> {
    return $("#itemSelection");
  }

  items(): number[] {
    return $(`.${ItemSelection.ITEM_CLASS}`)
      .map((i, elem) => parseInt($(elem).val() as string, 10))
      .get();
  }

  add(itemId: number): void {
    const strItemId = itemId.toString();
    if (this.items().indexOf(parseInt(strItemId, 10)) === -1) {
      const id = parseInt(strItemId, 10);
      const input = `<input class='${ItemSelection.ITEM_CLASS}' name='selection[]' type='hidden' value='${id}'>`;
      this.containerElement().append(input);
    }
  }

  remove(itemId: number): void {
    $(`.${ItemSelection.ITEM_CLASS}[value*='${itemId}']`).remove();
  }

  clear(): void {
    this.containerElement().empty();
  }
}

class CombinationDataSeriesQuery {
  private form: EasyResearchesControllerForm;
  private pairingItemId?: number | null;
  private selection?: number[];

  constructor(
    form: EasyResearchesControllerForm,
    pairingItemId?: number | null,
    selection?: number[],
  ) {
    this.form = form;
    this.pairingItemId = pairingItemId;
    this.selection = selection;
  }

  execute(): JQuery.Promise<any> {
    return $.ajax({
      url: this.form.combinationDataSeriesUrl(),
      dataType: "json",
      data: this.makeParams(),
    }).then((res: any) => {
      // 「定番」の場合はcombination_statsエンドポイントから返される形式を処理
      const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;

      let seriesData: any;
      if (isRegularResearch) {
        // combination_statsエンドポイントはseries_set配列を返す
        if (res.series_set && res.series_set.length > 0) {
          seriesData = res.series_set[0];
        } else {
          seriesData = res;
        }
      } else {
        // projected_statsエンドポイントの形式
        if (res.series_set && res.series_set.length > 0) {
          seriesData = res.series_set[0];
        } else {
          seriesData = res;
        }
      }

      // データの最初の日付をoriginとして使用
      let origin: DataDate | undefined;
      if (seriesData.values && seriesData.values.length > 0) {
        const firstValue = seriesData.values[0];
        if (Array.isArray(firstValue) && firstValue.length > 0) {
          const firstDateStr = firstValue[0]; // [date, value]の形式
          const partition = isRegularResearch ? "yearly" : "monthly";
          origin = DataDate.parseYMD(firstDateStr, partition) || undefined;
        }
      }

      // originが設定されていない場合は、startDate()を使用（後方互換性のため）
      if (!origin) {
        origin = this.startDate();
      }

      return new Series(seriesData.values, seriesData.name, origin);
    });
  }

  private makeParams(): any {
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;

    const params: any = {
      type: this.form.type(),
      partition: this.form.partition(),
      start: isRegularResearch ? this.form.startDate() : this.startDate().ymd(),
      end: this.form.targetDataDate().ymd(),
      dimension: this.form.dimension(),
      area: this.form.area(),
      category: this.form.category(),
    };

    // 「定番」の場合はpairing_item_idを使用、それ以外はpairing_item_idsを使用
    if (isRegularResearch) {
      if (this.pairingItemId != null) {
        params.pairing_item_id = this.pairingItemId;
      } else if (this.selection && this.selection.length > 0) {
        params.pairing_item_id = this.selection[0];
      }
    } else {
      if (this.pairingItemId != null) {
        params.pairing_item_id = this.pairingItemId;
      } else {
        params.pairing_item_ids = this.selection;
      }
    }

    return params;
  }

  private startDate(): any {
    // 「定番」の場合は2009-01-01を開始日として使用（DataDate形式）
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      const startDateStr = this.form.startDate();
      return DataDate.parseYMD(startDateStr, "yearly");
    }

    const end = this.form.targetDataDate();
    switch (end.partition) {
      case "weekly":
        return end.partitionStartDate().weeksAgo(11);
      case "monthly":
        return end.partitionStartDate().yearsAgoByDays(0.97);
      case "yearly":
        return new DataDate(tablemill.FIRST_DATA_DATE, "yearly");
      default:
        return end.partitionStartDate();
    }
  }

  csvUrl(): string {
    const isRegularResearch = $("#ksi_graph").closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      return `/combinations/${this.form.itemId()}/stats.csv?${$.param(this.makeParams())}`;
    }
    const keyword = encodeURIComponent(this.form.keyword());
    return `/easy_researches/${keyword}/projected_stats.csv?${$.param(this.makeParams())}`;
  }
}

export { EasyResearchesController };
